interface DOMElements {
  container: HTMLElement
  navbar: HTMLElement
  toggle: NodeListOf<HTMLElement>
}

export class MobileMenu {
  DOM: DOMElements
  active: boolean

  constructor() {
    this.DOM = {
      container: <HTMLElement>document.querySelector('.js-mobile-menu'),
      navbar: <HTMLElement>document.querySelector('.js-navbar'),
      toggle: document.querySelectorAll('.js-hamburger'),
    }

    this.active = false

    this.init()
  }

  private init() {
    this.bindEvents()
  }

  private bindEvents() {
    this.DOM.toggle.forEach(item => item.addEventListener('click', () => this.toggle()))
  }

  private toggle() {
    const method = this.active ? 'remove' : 'add'
    this.DOM.container.classList[method]('is-active')
    this.DOM.navbar.classList[method]('is-active-force')
    this.DOM.toggle.forEach(item => item.classList[method]('is-active'))

    this.active = !this.active
  }
}
